<template>
    <div class="mdc-snackbar">
        <div class="mdc-snackbar__surface">
            <div class="mdc-snackbar__label"
                role="status"
                aria-live="polite" v-html="contents">
                
            </div>
            <div class="mdc-snackbar__actions" v-if="btnDisplayYN">
                <button type="button" class="mdc-button btn-snack" @click="close()">{{btnDisplay}}</button>
            </div>
        </div>
    </div>
                
</template>

<script>
/**
 * snackbar component
 *
 * @author minkyoung.park@emcast.com
 */
// Import component
import {MDCSnackbar} from '@material/snackbar'

export default {
    data() {
        return {
            snackbar: null,
            resolved: null,
            rejected: null,
            contents: '',
            btnDisplay: 'confirm',
            btnDisplayYN: true
        }
    },

    methods: {
        attachMaterial(el) {
            this.snackbar = new MDCSnackbar(el);
            this.snackbar.listen('MDCSnackbar:closing', () => {
                this.close()
            })
        },
        
        open(payload){
            this.contents = payload.contents
            if (payload.btnDisplay) {
                this.btnDisplay = payload.btnDisplay
            }else {
                this.alertCancel = 'OK'
            }

            if (payload.timeoutMs && (payload.timeoutMs >= 4000 || payload.timeoutMs <= 10000)) {
                this.snackbar.timeoutMs = payload.timeoutMs
            }

            this.btnDisplayYN = payload.btnDisplayYN

            return new Promise((resolve, reject) => {
                this.snackbar.open()
            })
        },

        close() {
            this.contents = ''
            this.snackbar.close()
        }
    }
}
</script>
